export enum PlanPageViewMode {
  TABLE = 'table',
  CARD = 'card'
}
